import React from 'react'

import { H2 } from '@homebot/shared-ui-swashbuckle'

const defaultProps = {
  weight: 'light',
  color: 'neutral',
}

const Heading = props => <H2 {...props} />

Heading.defaultProps = defaultProps

export default Heading
